module.exports = __webpack_public_path__ + "media/images/athletes/1762-08fca7a619393d2d48401cb8d9d596e1.png";